import { Dropdown } from 'antd';
import styled from 'styled-components';

export const StyledAppDropdown = styled(Dropdown)`
  font-size: ${({ theme }) => theme.font.size.lg};
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.base};
  border: 1px solid ${({ theme }) => theme.palette.neutral[300]};
  padding: 9px 12px;
  cursor: pointer;

  display: flex;
  align-items: center;
  .ant-space-item {
    width: auto;
    height: 20px;
  }
  .img-icon {
    width: 20px;
    height: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
